import { ReactNode } from 'react';

import { Box, SimpleGrid } from '@chakra-ui/react';

import { trackEvent } from '~/features/analytics/track-event';
import { getFormalDegreeKey } from '~/features/analytics/utils/get-formal-degree-key';
import { CatalogItem } from '~/features/catalog/models/catalog-item';
import { CatalogSearchItem } from '~/features/catalog/models/catalog-search-result';
import { CatalogCard, CatalogCardSkeleton } from '~/features/experiments/ab_plp_redesign_2025/components/catalog-card';

export type CatalogCardRowProps = {
  titleSlot: ReactNode;
  catalogItems?: CatalogItem[] | CatalogSearchItem[];
  isLoading?: boolean;
  maxCards?: number;
};

export function CatalogCardRow({ titleSlot, catalogItems, isLoading, maxCards = 5 }: CatalogCardRowProps) {
  return (
    <Box>
      {titleSlot}
      <SimpleGrid columns={{ base: 2, lg: 4, xl: maxCards }} spacing='16px'>
        {!isLoading &&
          catalogItems?.slice(0, maxCards).map((catalogItem) => (
            <CatalogCard
              key={catalogItem.key}
              catalogItem={catalogItem}
              width='100%'
              priority
              onClick={() => {
                const formalDegreeKey = getFormalDegreeKey(catalogItem);
                trackEvent({
                  type: 'click',
                  name: 'searchCtaClicked',
                  label: catalogItem.title!,
                  action: 'program_card_clicked',
                  ...(formalDegreeKey && {
                    additionalAttributes: {
                      formal_degree_key: formalDegreeKey,
                    },
                  }),
                });
              }}
            />
          ))}
        {isLoading && Array.from({ length: maxCards }, (_, i) => <CatalogCardSkeleton key={i} width='100%' />)}
      </SimpleGrid>
    </Box>
  );
}
